import { Stack, Typography } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';

export interface OwnersListOwner {
  id: string;
  name?: string;
}

interface OwnersListProps {
  owners: OwnersListOwner[];
  renderOwner?: (owner: OwnersListOwner) => React.ReactNode;
  icon?: React.ReactNode;
}

const defaultRenderOwner = ({ id, name }: OwnersListOwner) => name ?? id;

const OwnersList = ({ owners, renderOwner = defaultRenderOwner, icon }: OwnersListProps) => {
  const [firstOwner, ...additionalOwners] = owners;

  if (!firstOwner) return null;

  return (
    <Stack direction="row" gap={0.5} sx={{ alignItems: 'center', flexShrink: 0 }}>
      {icon}
      {renderOwner(firstOwner)}

      {additionalOwners.length ? (
        <Tooltip
          placement="bottom"
          title={
            <Stack gap={0.5}>
              {additionalOwners.map(owner => (
                <span key={owner.id}>{renderOwner(owner)}</span>
              ))}
            </Stack>
          }
        >
          <Typography
            component="span"
            variant="body2"
            role="img"
            aria-label={`Additional owners: ${additionalOwners.map(owner => owner.name ?? owner.id).join(', ')}`}
            tabIndex={0}
            sx={{ color: 'brand', cursor: 'pointer', whiteSpace: 'nowrap' }}
          >
            + {additionalOwners.length}
          </Typography>
        </Tooltip>
      ) : null}
    </Stack>
  );
};

export default OwnersList;
